<template>
  <div>
    <!-- 头部 -->
    <div class="head">区域：舜泰汽车有限公司</div>
    <el-tabs style="padding-left:1%" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="任务管理" name="first">
        <!-- 任务管理 -->
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
          <el-form-item label="搜索：">
            <el-input size="small" v-model="formInline.deptName" placeholder="请输入任务名称"></el-input>
          </el-form-item>
          <el-form-item>

            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="primary"
              icon="el-icon-plus"
              @click="handleAdd()"
              >新建任务</el-button
            >

          </el-form-item>
        </el-form>
        <!--列表-->
        <el-table class="elTable" size="small" :data="listData" highlight-current-row v-loading="loading" border
          element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" prop="ID" label="ID" width="80"></el-table-column>

          <el-table-column
            align="center"
            prop="taskName"
            label="任务名称"
            width="250"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="lineName"
            label="线路名称"
            width="250"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="car"
            label="执行车辆"
            width="250"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="lineName"
            label="电量阈值"
            width="250"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="lineName"
            label="运行次数"
            width="250"
          ></el-table-column>

          <el-table-column align="center" prop="" label="任务状态" width="250">
            <el-tag type="success" size='small'>执行中</el-tag>
          </el-table-column>
          <el-table-column align="center" prop="editTime" label="创建时间" width="250">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="note" label="备注" width="250"></el-table-column>
          <el-table-column align="center" fixed="right" label="操作" min-width="250">
            <template slot-scope="scope">
              <el-button size="mini" round>详情</el-button>
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" round>编辑</el-button>
              <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)" round>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination
          v-bind:child-msg="pageparm"
          @callFather="callFather"
        ></Pagination>
        <!-- 添加 -->
        <el-dialog
          title="添加"
          :visible.sync="addFormVisible"
          width="30%"
          @click="closeDialog"
        >
          <el-form
            style="padding-right: 9%"
            label-width="120px"
            :model="addForm"
            :rules="rules"
            ref="addForm"
          >
            <el-form-item label="任务名称" prop="taskName">
              <el-input
                size="small"
                v-model="addForm.taskName"
                auto-complete="off"
                placeholder="请输入任务名称"
              ></el-input>
            </el-form-item>

            <el-form-item label="选择车辆" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleCar = true" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ car }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地图选择" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleMap = true" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ carMap }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="routeShow" label="线路选择" prop="route">
              <div class="chooseMap">
                <div @click="innerVisibleRoute = true" class="in_chooseMap">
                  <div style="margin-left: 3%">{{ carRouter }}</div>
                  <div style="float: right">></div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="电量阈值" prop="ele">
              <el-input
                size="small"
                v-model="addForm.ele"
                auto-complete="off"
                placeholder="请输入电量阈值"
              ></el-input>
            </el-form-item>
            <el-form-item label="开始时间" required>
              <el-date-picker
                style="width: 100%"
                v-model="start_time"
                type="datetime"
                placeholder="选择日期时间"
                default-time="12:00:00"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" required>
              <el-date-picker
                style="width: 100%"
                v-model="end_time"
                type="datetime"
                placeholder="选择日期时间"
                default-time="12:00:00"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="运行次数" prop="run_num">
              <el-input
                size="small"
                v-model="addForm.run_num"
                auto-complete="off"
                placeholder="请输入运行次数"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="type">
              <el-input
                type="textarea"
                size="small"
                v-model="addForm.type"
                auto-complete="off"
                placeholder="请输入备注"
              >
              </el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="closeDialog('addForm')">取 消</el-button>
            <el-button type="primary" @click="closeDialog('addForm')"
              >确 定</el-button
            >
          </span>

          <!-- 内层选择车辆 -->
          <el-dialog
            width="30%"
            title="选择车辆"
            :visible.sync="innerVisibleCar"
            append-to-body
          >
            <el-form :inline="true" :model="formInlines" class="user-search1">
              <el-form-item label="搜索：">
                <el-input
                  size="small"
                  v-model="formInlines.deptName"
                  placeholder="请输入车辆编号"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                  >搜索</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="chooseCar"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridDatas">
              <el-table-column
                align="center"
                width="50"
                type="selection"
                reserve-selection
              ></el-table-column>
              <el-table-column
                align="center"
                property="name"
                label="车辆编号"
                width="200"
              ></el-table-column>
              <el-table-column
                align="center"
                property="address"
                label="车牌号"
              ></el-table-column>
            </el-table>
            <Pagination
              v-bind:child-msg="pageparm"
              @callFather="callFather"
            ></Pagination>
          </el-dialog>
          <!-- --------选择车辆结束 -->
          <!-- 内层选择地图 -->
          <el-dialog
            width="30%"
            title="选择地图"
            :visible.sync="innerVisibleMap"
            append-to-body
          >
            <el-form :inline="true" :model="formInlines" class="user-search1">
              <el-form-item label="搜索：">
                <el-input
                  size="small"
                  v-model="formInlines.deptName"
                  placeholder="请输入地图名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                  >搜索</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="chooseMap"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridDatalist">
              <el-table-column
                align="center"
                width="50"
                type="selection"
                reserve-selection
              ></el-table-column>
              <el-table-column
                align="center"
                property="map_name"
                label="地图名称"
                width="200"
              ></el-table-column>
              <el-table-column
                align="center"
                property="map_number"
                label="地图编号"
              ></el-table-column>
            </el-table>
            <Pagination
              v-bind:child-msg="pageparm"
              @callFather="callFather"
            ></Pagination>
          </el-dialog>
          <!-- -------结束 -->

          <!-- 内层选择线路 -->
          <el-dialog
            width="30%"
            title="选择线路"
            :visible.sync="innerVisibleRoute"
            append-to-body
          >
            <el-form :inline="true" :model="formInlines" class="user-search1">
              <el-form-item label="搜索：">
                <el-input
                  size="small"
                  v-model="formInlines.deptName"
                  placeholder="请输入线路名称"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-search"
                  @click="search"
                  >搜索</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-button
                  size="small"
                  type="primary"
                  icon="el-icon-plus"
                  @click="chooseRoute"
                  >确定</el-button
                >
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column
                align="center"
                width="50"
                type="selection"
                reserve-selection
              ></el-table-column>
              <el-table-column
                align="center"
                property="name"
                label="线路名称"
                width="200"
              ></el-table-column>
              <el-table-column
                align="center"
                property="address"
                label="线路编号"
              ></el-table-column>
            </el-table>
            <Pagination
              v-bind:child-msg="pageparm"
              @callFather="callFather"
            ></Pagination>
          </el-dialog>
          <!-- 内层选择线路-->
        </el-dialog>
        <!-- 编辑界面 -->

        <el-dialog
          title="修改"
          :visible.sync="editFormVisible"
          width="30%"
          @click="closeDialog"
        >
          <el-form
            style="padding-right: 9%"
            label-width="120px"
            :model="editForm"
            :rules="rules"
            ref="editForm"
          >

            <el-form-item label="任务名称" prop="taskName">
              <el-input size="small" v-model="editForm.taskName" auto-complete="off" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            
            <el-form-item label="选择车辆" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleCar = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{car}}</div>
                  <div style="float: right;">> </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地图选择" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleMap = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{carMap}} </div>
                  <div style="float: right;"> > </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="routeShow" label="线路选择" prop="route">
              <div class="chooseMap">
                <div @click="innerVisibleRoute = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{carRouter}}</div>
                  <div style="float: right;">> </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="电量阈值" prop="ele">
              <el-input size="small" v-model="editForm.ele" auto-complete="off" placeholder="请输入电量阈值"></el-input>
            </el-form-item>
            <el-form-item label="开始时间" required>
              <el-date-picker style="width: 100%;" v-model="start_time" type="datetime" placeholder="选择日期时间"
                default-time="12:00:00">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" required>
              <el-date-picker style="width: 100%;" v-model="end_time" type="datetime" placeholder="选择日期时间"
                default-time="12:00:00">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="运行次数" prop="run_num">
              <el-input size="small" v-model="editForm.run_num" auto-complete="off" placeholder="请输入运行次数"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="type">
              <el-input type="textarea" size="small" v-model="editForm.type" auto-complete="off" placeholder="请输入备注">
              </el-input>
            </el-form-item>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog('addForm')">取 消</el-button>
          <el-button type="primary" @click="closeDialog('addForm')">确 定</el-button>
        </span>

          <!-- 内层选择车辆 -->
          <el-dialog
            width="30%"
            title="选择车辆"
            :visible.sync="innerVisibleCar"
            append-to-body
          >
            <el-form
              :inline="true"
              :model="editformInline"
              class="user-search1"
            >
              <el-form-item label="搜索：">
                <el-input
                  size="small"
                  v-model="editformInline.deptName"
                  placeholder="请输入车辆编号"
                ></el-input>

              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseCar">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="车辆编号" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="车牌号"></el-table-column>

            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- --------选择车辆结束 -->
          <!-- 内层选择地图 -->
          <el-dialog width="30%" title="选择地图" :visible.sync="innerVisibleMap" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptName" placeholder="请输入地图名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseMap">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="地图名称" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="地图编号"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- -------结束 -->

          <!-- 内层选择线路 -->
          <el-dialog width="30%" title="选择线路" :visible.sync="innerVisibleRoute" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptName" placeholder="请输入线路名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseRoute">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="线路名称" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="线路编号"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- 内层选择线路-->

        </el-dialog>
        <!-- 编辑 -->
         <el-dialog title="添加" :visible.sync=" addFormVisible" width="30%" @click="closeDialog">
          <el-form style="padding-right:9%" label-width="120px" :model="addForm" :rules="rules" ref="addForm">
            <el-form-item label="任务名称" prop="taskName">
              <el-input disabled size="small" v-model="addForm.taskName" auto-complete="off" placeholder="请输入任务名称"></el-input>
            </el-form-item>
            
            <el-form-item label="选择车辆" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleCar = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{car}}</div>
                  <div style="float: right;">> </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="地图选择" prop="map">
              <div class="chooseMap">
                <div @click="innerVisibleMap = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{carMap}} </div>
                  <div style="float: right;"> > </div>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="routeShow" label="线路选择" prop="route">
              <div class="chooseMap">
                <div @click="innerVisibleRoute = true" class="in_chooseMap">
                  <div style="margin-left: 3%;">{{carRouter}}</div>
                  <div style="float: right;">> </div>
                </div>
              </div>
            </el-form-item>
            
            <el-form-item label="电量阈值" prop="ele">
              <el-input size="small" v-model="addForm.ele" auto-complete="off" placeholder="请输入电量阈值"></el-input>
            </el-form-item>
            <el-form-item label="开始时间" required>
              <el-date-picker style="width: 100%;" v-model="start_time" type="datetime" placeholder="选择日期时间"
                default-time="12:00:00">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" required>
              <el-date-picker style="width: 100%;" v-model="end_time" type="datetime" placeholder="选择日期时间"
                default-time="12:00:00">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="运行次数" prop="run_num">
              <el-input size="small" v-model="addForm.run_num" auto-complete="off" placeholder="请输入运行次数"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="type">
              <el-input type="textarea" size="small" v-model="addForm.type" auto-complete="off" placeholder="请输入备注">
              </el-input>
            </el-form-item>
          </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeDialog('addForm')">取 消</el-button>
          <el-button type="primary" @click="closeDialog('addForm')">确 定</el-button>
        </span>

          <!-- 内层选择车辆 -->
          <el-dialog width="30%" title="选择车辆" :visible.sync="innerVisibleCar" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptName" placeholder="请输入车辆编号"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseCar">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="车辆编号" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="车牌号"></el-table-column>

            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- --------选择车辆结束 -->
          <!-- 内层选择地图 -->
          <el-dialog width="30%" title="选择地图" :visible.sync="innerVisibleMap" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptName" placeholder="请输入地图名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseMap">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="地图名称" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="地图编号"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- -------结束 -->

          <!-- 内层选择线路 -->
          <el-dialog width="30%" title="选择线路" :visible.sync="innerVisibleRoute" append-to-body>
            <el-form :inline="true" :model="formInline" class="user-search1">
              <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.deptName" placeholder="请输入线路名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
              </el-form-item>
              <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="chooseRoute">确定</el-button>
              </el-form-item>
            </el-form>
            <el-table ref=" multipleTable" :data="gridData">
              <el-table-column align="center" width="50" type="selection" reserve-selection></el-table-column>
              <el-table-column align="center" property="name" label="线路名称" width="200"></el-table-column>
              <el-table-column align="center" property="address" label="线路编号"></el-table-column>
            </el-table>
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
          </el-dialog>
          <!-- 内层选择线路-->

        </el-dialog>
        <!-- 任务管理结束 -->
      </el-tab-pane>


      <el-tab-pane label="区域车辆" name="second">
        <car />
      </el-tab-pane>
      <el-tab-pane label="区域线路" name="third">
        <areaLine />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import car from "../area_mn/area_car";
  import areaLine from "../area_mn/line";

import Pagination from "../../components/Pagination";
export default {
  name: "task",
  data() {
    return {
      carRouter: "",
      car: "",
      routeShow: false,
      carMap: "地图1",
      start_time: "",
      end_time: "",
      time2: "",
      addFormVisible: false,
      // 地图选择
      gridDatas: [
        {
          name: "地图1",
          address: "10051005",
        },
      ],
      gridDatalist: [
        {
          map_name: "地图1",
          map_number: "10051005",
        },
      ],
      gridData: [
        {
          name: "地图1",
          address: "10051005",

        }],
        editForm: {
          ele: '',
          clean: false,
          water: false,
          ID: "",
          taskName: "",
          lineName: "",
          car: "",
          note: "",
          waterLevel: "",
          date1: "",
          date2: "",
          run_num: '',
          token: localStorage.getItem("logintoken")
        },
        // rules表单验证
        rules: {
          taskName: [
            { required: true, message: "请输入任务名称", trigger: "blur" }
          ],
          lineName: [
            { required: true, message: "请输入线路名称", trigger: "blur" }
          ],
          car: [{ required: true, message: "请输入执行车辆", trigger: "blur" }],
          waterLevel: [{ required: true, message: "请输入水位阈值", trigger: "blur" }],
          ele: [{ required: true, message: "请输入电量阈值", trigger: "blur" }],
          run_num: [{ required: true, message: "请输入运行次数", trigger: "blur" }],
          date1: [
            {
              type: "date",
              required: true,
              message: "请选择日期",
              trigger: "change"
            }
          ],
          date2: [
            {
              type: "date",
              required: true,
              message: "请选择时间",
              trigger: "change"
            }
          ]
        },

      dialogChooseCar: false,
      innerVisibleCar: false,
      innerVisibleRoute: false,
      innerVisibleMap: false,
      activeName: "first",
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      addForm: {
        ele: "",
        clean: false,
        water: false,
        ID: "",
        taskName: "",
        lineName: "",
        car: "",
        note: "",
        waterLevel: "",
        date1: "",
        date2: "",
        run_num: "",
        token: localStorage.getItem("logintoken"),
      },
      editForm: {
        ele: "",
        clean: false,
        water: false,
        ID: "",
        taskName: "",
        lineName: "",
        car: "",
        note: "",
        waterLevel: "",
        date1: "",
        date2: "",
        run_num: "",
        token: localStorage.getItem("logintoken"),
      },
      // rules表单验证
      rules: {
        taskName: [
          { required: true, message: "请输入任务名称", trigger: "blur" },
        ],
        lineName: [
          { required: true, message: "请输入线路名称", trigger: "blur" },
        ],
        car: [{ required: true, message: "请输入执行车辆", trigger: "blur" }],
        waterLevel: [
          { required: true, message: "请输入水位阈值", trigger: "blur" },
        ],
        ele: [{ required: true, message: "请输入电量阈值", trigger: "blur" }],
        run_num: [
          { required: true, message: "请输入运行次数", trigger: "blur" },
        ],
        date1: [
          {
            type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        date2: [
          {
            type: "date",
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
      },
      formInlines: {
        page: 1,
        limit: 10,
        deptName: "",
        varName: "",
      },
      editInline: {
        page: 1,
        limit: 10,
        deptName: "",
      },
      editformInline: {
        page: 1,
        limit: 10,
        varLable: "",
        deptName: "",
        token: localStorage.getItem("logintoken"),
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: "",
        deptName: "",
        token: localStorage.getItem("logintoken"),
      },
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },

  // 注册组件
  components: {
    Pagination,
    car,
    areaLine,
  },
  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline);
  },
  methods: {
    // 选择车辆
    chooseCar() {
      this.innerVisibleCar = false;
      console.log("11111111111111111111111");
    },
    // 选择地图
    chooseMap() {
      this.innerVisibleMap = false;
      this.routeShow = true;
    },
    // 选择线路
    chooseRoute() {
      this.innerVisibleRoute = false;
    },

    handleClick(tab, event) {
      console.log(tab, event);
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true;
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,
        data: [
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
          {
            ID: 1005,
            taskName: "测试测试",
            lineName: "测试测试",
            car: "测试测试",
            addTime: 1526453107000,
            editTime: 1526453107000,
            note: "测试测试",
            deptName: "v",
            deptNo: "v",
            parentId: 1,
          },
        ],
      };
      this.loading = false;
      this.listData = res.data;
      this.pageparm.currentPage = this.formInline.page;
      this.pageparm.pageSize = this.formInline.limit;
      this.pageparm.total = res.count;
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage;
      this.formInline.limit = parm.pageSize;
      this.getdata(this.formInline);
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline);
    },
    handleAdd() {
      this.addFormVisible = true;
    },
    //显示编辑界面
    handleEdit() {
      this.editFormVisible = true;
    },

    // 编辑、增加页面保存方法
    /* submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          deptSave(this.editForm)
            .then((res) => {
              this.editFormVisible = false;
              this.loading = false;
              if (res.success) {
                this.getdata(this.formInline);
                this.$message({
                  type: "success",
                  message: "保存成功！",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.loading = false;
              this.$message.error("保存失败，请稍后再试！");
            });
        } else {
          return false;
        }
      });
    }, */
    // 删除公司
    /*   deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deptDelete(row.deptId)
            .then((res) => {
              if (res.success) {
                this.$message({
                  type: "success",
                  message: "已删除!",
                });
                this.getdata(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    }, */
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
      this.addFormVisible = false;
    },


  }
}
</script>
<style scoped>
  .head {
    width: 99%;
    padding-bottom: 1%;
    margin-top: 1%;
    margin-left: 1%;
    font-size: 20px;
    color: #334157;
    /* border-bottom: 1px solid #f5f5f5; */
  }


  .elTable /deep/ td {
    padding: 0.3% 0 !important;
  }

  el-tabs {
    margin-left: 1%;
  }

  .user-search {
    margin-top: 20px;
  }

  .user-search1 {
    margin-top: 0;
  }

  .userRole {
    width: 100%;
  }

  /* 添加编辑弹框 */
  .chooseMap {
    margin-top: 1%;
    width: 100%;
    height: 30px;
    line-height: 30px;
    /* background-color: violet; */
    border: #dcdfe6 1px solid;
    border-radius: 3px;
  }

  .in_chooseMap {
    height: 30px;
    display: flex;
    justify-content: space-between;
    color: #888;
    margin-right: 2%;
  }
</style>


// WEBPACK FOOTER //
// src/views/area_mn/task_mn.vue